import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  inject,
  signal,
} from '@angular/core';

const ROTATE_INTERVAL_MS = 2200;

const WAITING_WORDS = [
  'Hoisting',
  'Slewing',
  'Telescoping',
  'Rigging',
  'Winching',
  'Booming',
  'Levelling',
  'Craining',
  'Pecking',
];

/** Rotating label shown while the assistant works; visibility is set in styles.scss. */
@Component({
  selector: 'pc-status',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<p class="pc-status" aria-hidden="true">{{ $word() }}…</p>`,
  styles: `
    .pc-status {
      margin: 0;
      padding: calc(0.4 * var(--ds-spacing)) calc(0.8 * var(--ds-spacing));
      color: var(--ds-neutral-400);
      font-size: 13px;
      font-style: italic;
    }
  `,
})
export class PalchatStatusComponent {
  private readonly _$tick = signal(0);

  protected readonly $word = computed(
    () => WAITING_WORDS[this._$tick() % WAITING_WORDS.length],
  );

  constructor() {
    const rotation = setInterval(
      () => this._$tick.update((tick) => tick + 1),
      ROTATE_INTERVAL_MS,
    );

    inject(DestroyRef).onDestroy(() => clearInterval(rotation));
  }
}
